<template>
  <div>
    <div
      @click="clickHandler"
      :class="styles.name(point, selected)"
      class="name"
    >
      {{ point.name }}
    </div>
  </div>
</template>

<script>
import nameStyles from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/nameStyles'
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'

export default {
  name: 'Name',
  props: { point: Object },
  computed: {
    styles() {
      return nameStyles
    },
    selectedPoint() {
      return this.$store.getters[getters.selectedPoint]
    },
    selected() {
      const point = this.point
      const selectedPoint = this.selectedPoint

      // 既存のポイントの場合（フェッチした時に存在する）
      if (!point.newItem.new) {
        return point.id === selectedPoint.id
      }
      // 新規ポイントの場合（フェッチした時に存在しない）
      return point.newItem.id === selectedPoint.newItem.id
    },
  },
  methods: {
    clickHandler() {
      this.$store.dispatch(actions.SET_SELECTED_POINT, { data: this.point })
    },
  },
}
</script>

<style scoped lang="scss">
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
